export default __webpack_public_path__ + "static/media/background.7d743ec8.png";